var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstetico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 0.5C13.7891 0.5 14.1797 0.669271 14.4922 1.00781C14.8307 1.32031 15 1.71094 15 2.17969V13.8203C15 14.2891 14.8307 14.6927 14.4922 15.0312C14.1797 15.3438 13.7891 15.5 13.3203 15.5H1.67969C1.21094 15.5 0.807292 15.3438 0.46875 15.0312C0.15625 14.6927 0 14.2891 0 13.8203V2.17969C0 1.71094 0.15625 1.32031 0.46875 1.00781C0.807292 0.669271 1.21094 0.5 1.67969 0.5H13.3203ZM7.5 8C7.96875 8 8.38542 7.89583 8.75 7.6875C9.14062 7.45312 9.4401 7.15365 9.64844 6.78906C9.88281 6.39844 10 5.96875 10 5.5C10 5.03125 9.88281 4.61458 9.64844 4.25C9.4401 3.85938 9.14062 3.5599 8.75 3.35156C8.38542 3.11719 7.96875 3 7.5 3C7.03125 3 6.60156 3.11719 6.21094 3.35156C5.84635 3.5599 5.54688 3.85938 5.3125 4.25C5.10417 4.61458 5 5.03125 5 5.5C5 5.96875 5.10417 6.39844 5.3125 6.78906C5.54688 7.15365 5.84635 7.45312 6.21094 7.6875C6.60156 7.89583 7.03125 8 7.5 8ZM5.82031 5.07031V5.92969H6.67969V5.07031H5.82031ZM7.07031 5.07031V5.92969H7.92969V5.07031H7.07031ZM8.32031 5.07031V5.92969H9.17969V5.07031H8.32031Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstetico);
export default __webpack_public_path__ + "static/media/estetico.d0d74aaaf293e1ad234033f726735e00.svg";
export { ForwardRef as ReactComponent };